import React, { Suspense, useState, useEffect, useRef } from "react";
import systemListingService from "./SystemListingServices";
import ProductStatusUpsert from "./upsert/ProductStatusUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function ProductStatus(param: any) {

  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  let [openUpsertUX, setOpenUpsertUX] = useState(false);
  let [editDataDawer, seteditDataDawer] = useState<any>([]);
  let [editingOn, setEditingOn] = useState(false);
  let [ProductStatus, SetProductStatus] = useState<any>([]);

  useEffect(() => {
    if (param.activeTab === "Product Status") {
      ProductStatusSelect()
    }
  }, [param]);

  const ProductStatusSelect = () => {
    var payload = {}
    systemListingService.statusProductList(payload).then((res: any) => { SetProductStatus(res) });
  };

  const openAddDrawer = (e: any) => {
    editDataDawer = e
    seteditDataDawer(editDataDawer)
    openUpsertUX = true
    setOpenUpsertUX(openUpsertUX)
  };

  const closeUpsertUX = () => {
    setOpenUpsertUX(!openUpsertUX)
  }

  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    if (e == 1) {
      systemFormatsList.deletestatusProduct(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Product Status delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  }

  const slider_handler = (e: any, selectData: any) => {

    if (e.target.type == "checkbox") {

      selectData[e?.target?.name] = selectData[e?.target?.name] == 1 ? 0 : 1

      systemListingService.saveStatusAccountExt(selectData).then((repond: any) => {
        ProductStatusSelect();
      })
    }
  }

  return (
    <div className="content-card ws-12">

      <div className="ptl pbl ws-12">
        <span className="text-bold">Product Status</span>
        <button className="icon-btn info pull-right" type="button" onClick={() => setEditingOn((prev) => !prev)}  >          {editingOn ? "Edit Mode: On" : "Edit Mode: Off"} </button>

        <div className=" ws-12 mt">
          <button className="icon-btn primary height35 pull-right fill" type="button" disabled={!editingOn} onClick={() => openAddDrawer({})}  > Add Product Status</button>
          <button className="btn-save-table hide" type="button" disabled={!editingOn} onClick={() => { setEditingOn(false); }} > Save Changes </button>
        </div>
      </div>

      <div className="ws-12">
        <table className={editingOn ? "editing-on newTable" : " newTable"} >
          <thead>
            <tr>
              <th >Status ID</th>
              <th >Status Name</th>
              <th >Short Code</th>
              <th >Song YN</th>
              <th >Track YN</th>
              <th >Release YN</th>
              <th >Cue YN</th>
              <th >Show Hide YN</th>
              <th >Owned YN</th>
              <th >InterCo YN</th>
              <th style={{ width: "17%" }}>Operations</th>
            </tr>
          </thead>
          <tbody>
            {ProductStatus.map((row: any) => (
              <tr key={row.id}>
                <td>{row.productStatusUseID}</td>
                <td>

                  <span style={{
                    background: CommonUtilities.lookUpTypeList('statusProductName', row.productStatusName, 'bgColor'),
                    color: CommonUtilities.lookUpTypeList('statusProductName', row.productStatusName, 'fontColor'),
                    borderRadius: "4px"
                  }} className="pm forceSingleLine">
                    {row.productStatusName}
                  </span>
                </td>
                <td>{row.ProductStatusShortCode}</td>

                <td>
                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="songYN" checked={row?.songYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.songYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.songYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>

                </td>

                <td>

                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="trackYN" checked={row?.trackYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.trackYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.trackYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>

                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="releaseYN" checked={row?.releaseYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.releaseYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.releaseYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>

                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="cueYN" checked={row?.cueYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.cueYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.cueYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>

                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="showHideYN" checked={row?.showHideYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.showHideYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.showHideYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>
                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="ownedYN" checked={row?.ownedYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.ownedYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.ownedYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>

                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="interCoYN" checked={row?.interCoYN === 1} onChange={(e: any) => slider_handler(e, row)}/>
                    {row?.interCoYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.interCoYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}>

                  <div className="width225">
                    <button className={`icon-btn info ${row.isDefault ? "fill" : ""}`} type="button" disabled={!editingOn} >Default</button>
                    <button className="icon-btn edit" title="Edit " type="button" disabled={!editingOn} onClick={() => openAddDrawer(row)}><i className="icon-pencil"></i> </button>
                    <button className="icon-btn delete" type="button" disabled={!editingOn} onClick={() => deleteSelection(row)}><i className="icon-trash"> </i> </button>
                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {
        (() => {
          if (openUpsertUX) {
            return <ProductStatusUpsert openUpsertUX={openUpsertUX} closeDrawer={closeUpsertUX} />
          }

          if (deleteStatus) {
            return <DeleteDialogueBox param={deleteStatus} message={"delete the selected product status " + deleteData?.productStatusName} onChange={deleteConfirmation} />
          }
        })()
      }

    </div>
  );
};